import { useState } from 'react'
import {
  Wrap,
  Label,
  Window,
  Row,
  ToggleBtn,
  SmallBtn,
  AddBtn,
  HourInput,
} from './components/schedule-editor-styles'

const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

const SEASON_PRESETS = [
  { label: 'Spring', months: [3, 4, 5] },
  { label: 'Summer', months: [6, 7, 8] },
  { label: 'Fall',   months: [9, 10, 11] },
  { label: 'Winter', months: [12, 1, 2] },
]

const toggle = (arr, val) =>
  arr ? (arr.includes(val) ? arr.filter(v => v !== val) : [...arr, val].sort((a, b) => a - b)) : [val]

const WindowEditor = ({ win, onChange, onRemove }) => {
  const setDays   = (d) => onChange({ ...win, days:   d.length ? d : undefined })
  const setMonths = (m) => onChange({ ...win, months: m.length ? m : undefined })
  const setHours  = (h) => onChange({ ...win, hours:  h })

  const applyPreset = (months) => {
    const cur = win.months || []
    const allPresent = months.every(m => cur.includes(m))
    const next = allPresent
      ? cur.filter(m => !months.includes(m))
      : [...new Set([...cur, ...months])].sort((a, b) => a - b)
    setMonths(next.length ? next : undefined)
  }

  const hoursStart = win.hours?.[0] ?? ''
  const hoursEnd   = win.hours?.[1] ?? ''

  return (
    <Window>
      <Row>
        <span style={{ minWidth: 55, color: 'rgba(255,255,255,0.45)' }}>Days</span>
        {DAYS.map((d, i) => (
          <ToggleBtn key={d} $on={win.days?.includes(i)} onClick={() => setDays(toggle(win.days, i))}>{d}</ToggleBtn>
        ))}
        <span style={{ color: 'rgba(255,255,255,0.25)', fontSize: '0.75rem' }}>(all if none)</span>
      </Row>

      <Row>
        <span style={{ minWidth: 55, color: 'rgba(255,255,255,0.45)' }}>Months</span>
        {MONTHS.map((m, i) => (
          <ToggleBtn key={m} $on={win.months?.includes(i + 1)} onClick={() => setMonths(toggle(win.months, i + 1))}>{m}</ToggleBtn>
        ))}
      </Row>
      <Row>
        <span style={{ minWidth: 55 }} />
        {SEASON_PRESETS.map(({ label, months }) => (
          <SmallBtn key={label} style={{ borderColor: '', color: '' }}
            onClick={() => applyPreset(months)}
            onMouseEnter={e => { e.target.style.borderColor = ''; e.target.style.color = ''; }}
          >{label}</SmallBtn>
        ))}
        <span style={{ color: 'rgba(255,255,255,0.25)', fontSize: '0.75rem' }}>(all if none)</span>
      </Row>

      <Row>
        <span style={{ minWidth: 55, color: 'rgba(255,255,255,0.45)' }}>Hours</span>
        <HourInput
          type="number" min={0} max={23} placeholder="0"
          value={hoursStart}
          onChange={e => {
            const v = parseInt(e.target.value, 10)
            setHours(isNaN(v) ? undefined : [v, typeof hoursEnd === 'number' ? hoursEnd : 17])
          }}
        />
        <span>–</span>
        <HourInput
          type="number" min={0} max={23} placeholder="24"
          value={hoursEnd}
          onChange={e => {
            const v = parseInt(e.target.value, 10)
            setHours(isNaN(v) ? undefined : [typeof hoursStart === 'number' ? hoursStart : 9, v])
          }}
        />
        <span style={{ color: 'rgba(255,255,255,0.35)', fontSize: '0.75rem' }}>24h, end exclusive (all if blank)</span>
      </Row>

      <SmallBtn onClick={onRemove}>Remove window</SmallBtn>
    </Window>
  )
}

export const ScheduleEditor = ({ value, onChange }) => {
  const windows = value || []

  const update = (i, win) => onChange(windows.map((w, j) => j === i ? win : w))
  const remove = (i) => {
    const next = windows.filter((_, j) => j !== i)
    onChange(next.length ? next : null)
  }
  const add = () => onChange([...windows, {}])

  return (
    <Wrap>
      <Label>Schedule (empty = always open)</Label>
      {windows.map((win, i) => (
        <WindowEditor key={i} win={win} onChange={(w) => update(i, w)} onRemove={() => remove(i)} />
      ))}
      <AddBtn onClick={add}>+ Add time window</AddBtn>
      {windows.length > 1 && (
        <span style={{ marginLeft: '0.75rem', color: 'rgba(255,255,255,0.35)', fontSize: '0.78rem' }}>
          open if ANY window matches
        </span>
      )}
    </Wrap>
  )
}
